import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { history } from "store";

import { Button, GlobalErrorMessage } from "shared/components";
import DocumentsList from "./DocumentsList";
import EditDocumentAdding from "./EditDocumentAdding";
import { DocumentFolder, enum_id_docs, enum_proof_of_address, ID_DOC_TYPE, } from "shared/enums/DocumentsTypes";
import { WrapMainForm } from "Funnel/Components/WrapPage";
import { hasRiverbankProvider } from "shared/utilities";
import "./documents.scss";
import { useParams } from "react-router-dom";

const BeneficiariesDocs = ({ match }) => {
  const { providerSlug, action } = useParams();
  const isUpdate = action === "update";
  const { docs, moreUploadNeeded } = useSelector(
    (store) => store.dashboard.documents.beneficiaries
  );
  const beneficiaries = useSelector(
    (store) => store.dashboard.benificiaries.list
  );
  const jddMandatory = useSelector((store) => hasRiverbankProvider({
    procedureProviderSlug: store.dashboard.procedure.providerSlug,
    accountProviders: store.dashboard.accounts.filterableProviders,
  }));
  const missingProofOfAddress = jddMandatory && beneficiaries.some(
    (x) => (docs[x.id] || []).filter((e) => e.document_type === 'proof_of_address').length === 0
  );

  const [edited_id, setEditedId] = useState(null);
  const [owner_id, setOwnerId] = useState(null);
  const [notCompleted, setNotCompleted] = useState(false);

  useEffect(() => setNotCompleted(false), [moreUploadNeeded, jddMandatory]);

  const handleValidate = async () => {
    if (!moreUploadNeeded && !missingProofOfAddress) {
      if (isUpdate) {
        history.goBack();
      } else {
        if (providerSlug) {
          history.push("/settings-confirm");
        } else {
          history.push("/accounts");
        }
      }
    } else {
      setNotCompleted(true);
    }
  };

  const zoneTitle = (person) => {
    if (!person) {
      return
    }
    const civilityStr = person.civility === "mr" ? "M" : "Mme";
    return `Pièce d’identité ${civilityStr}. ${person.last_name}`;
  };

  const proofOfResidenceTitle = (person) => {
    if (!person) {
      return
    }
    const civilityStr = person.civility === "mr" ? "M" : "Mme";
    return `Justificatif de domicile ${civilityStr}. ${person.last_name}`;
  };

  return (
    <div className="funnelPgW">
      <div className={`funnelPgContent ${edited_id ? "rightFormEdited" : ""}`}>
        <div className="funnelPgL">
          <WrapMainForm>
            {!isUpdate && !providerSlug && <div className="sectionName">4/4 — Documents</div>}
            <div className="formW">
              <div className="formH">
                <div className="goBack" onClick={() => history.goBack()}>
                  <i className="icon-arrow-back" />
                </div>
                <div className="formTitle">
                  {DocumentFolder.beneficiaries.label}
                </div>
              </div>
              <div className="requiredFields">
                <p>*Champs obligatoires</p>
              </div>
              <div>
                {beneficiaries.map((x, i) => (
                  <div key={i}>
                    <div className="docZone">
                      <div className="docTitle">{zoneTitle(x)}*</div>
                      <DocumentsList
                        folder={DocumentFolder.beneficiaries.key}
                        owner_id={x.id}
                        list={docs[x.id] ? docs[x.id].filter((e) => ID_DOC_TYPE.includes(e.document_type)) : []}
                        onAddingClick={() => {
                          setEditedId('ids');
                          setOwnerId(x.id);
                        }}
                        active={[owner_id, edited_id].join('-') === `${x.id}-ids`}
                        errorClass={notCompleted && docs[x.id].filter((e) => ID_DOC_TYPE.includes(e.document_type)).length === 0}
                      />
                    </div>

                    <div key={i} className="docZone">
                      <div className="docTitle">{proofOfResidenceTitle(x)}{jddMandatory ? "*" : ""}</div>
                      <DocumentsList
                        folder={DocumentFolder.beneficiaries.key}
                        owner_id={x.id}
                        list={docs[x.id] ? docs[x.id].filter((e) => e.document_type === 'proof_of_address') : []}
                        onAddingClick={() => {
                          setEditedId('proof-of-address');
                          setOwnerId(x.id);
                        }}
                        active={[owner_id, edited_id].join('-') === `${x.id}-proof-of-address`}
                        errorClass={notCompleted && jddMandatory && docs[x.id].filter((e) => e.document_type === 'proof_of_address').length === 0}
                      />
                    </div>
                  </div>
                ))}

                {notCompleted && (
                  <div className="docZone">
                    <GlobalErrorMessage>
                      Vous devez ajouter au moins un fichier par bénéficiaire
                      effectif.
                    </GlobalErrorMessage>
                  </div>
                )}

                <Button onClick={handleValidate} variant="contained" primary>
                  {isUpdate ? "Enregistrer" : "Suivant"}
                </Button>
              </div>
            </div>
          </WrapMainForm>
        </div>
        <div className="funnelPgR">
          {edited_id !== null && (
            <EditDocumentAdding
              title={edited_id === 'ids' ?
                zoneTitle(beneficiaries.find((x) => x.id === owner_id)) :
                proofOfResidenceTitle(beneficiaries.find((x) => x.id === owner_id))}
              folder={DocumentFolder.beneficiaries.key}
              owner_id={owner_id}
              selectEnum={edited_id === 'ids' ? enum_id_docs : enum_proof_of_address}
              close={() => {
                setEditedId(null)
                setOwnerId(null)
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BeneficiariesDocs;
